// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__RvTGG"};